/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    region: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode: string;
    /**
     * A 2-letter country code, must conform to ISO 3166-1 Alpha-2
     * @type {string}
     * @memberof Address
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    longitude: number | null;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('line2' in value) || value['line2'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'],
        'city': json['city'],
        'region': json['region'],
        'postalCode': json['postalCode'],
        'countryCode': json['countryCode'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

  export function AddressToJSON(json: any): Address {
      return AddressToJSONTyped(json, false);
  }

  export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'region': value['region'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

